<template>
  <b-modal
    id="modal-flag-detail"
    ref="modal"
    v-model="open"
    size="lg"
    no-close-on-backdrop
    hide-footer
    title="Flags"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <ValidationObserver
        ref="updateMerchantForm"
        v-slot="{ handleSubmit }"
        slim
      >
        <b-form
          class="my-8"
          @submit.prevent="handleSubmit(onClickSetFlag)"
        >
          <b-row>
            <b-col
              md="8"
              xs="12"
            >
              <b-form-group
                label="Action"
                label-for="h-name"
                label-cols-lg="3"
                label-cols-xs="12"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="flag"
                  rules="required"
                >
                  <v-select
                    v-model="selectedFlag"
                    :options="flagOptions"
                    :reduce="option => option"
                    label="name"
                    placeholder="Select the Action"
                    :disabled="isDisabled"
                  >
                    <template
                      v-slot:option="option"
                    >
                      {{ option.name }}
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              xs="12"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="ml-1"
              >
                Get Operation
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>
      <hr>
      <b-row class="mt-2">
        <b-col
          md="12"
        >
          <div v-if="action === 0">
            <SetRedelivery
              :waybill="wayBill"
              :set-open="setOpen"
              :refresh="refreshParent"
              :set-errors="setErrors"
              :flag-type="(selectedFlag && selectedFlag.type) ? selectedFlag.type : (form && form.length ? form[0].type : '')"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <b-alert
            variant="warning"
            :show="form.length === 0"
          >
            <h4 class="alert-heading">
              No Flags Have Been Set For This Order!!
            </h4>
          </b-alert>
        </b-col>

      </b-row>

      <div
        v-for="flag in form"
        :key="flag.key"
      >
        <b-list-group>
          <div
            v-if="flag.type === 'flag_1'"
          >
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-info"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="TruckIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>An Pickup Request has been placed to be picked up on <b>{{ flag.pivot.data.pickup_at }}</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length > 1"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_2'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-danger"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="AlertOctagonIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>An Urgent Request have been placed</span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length !== 0"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_3'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-primary"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="RepeatIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>An Exchange Request has been placed with Original Waybill <b>{{ flag.pivot.data.original_waybill_number }}</b> and Exchange to Waybill <b>{{ flag.pivot.data.exchange_waybill_number }}</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length > 2"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_4'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-dark"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="ArrowLeftIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>An Return Request has been placed to Original Waybill <b>{{ flag.pivot.data.original_waybill_number }}</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length > 1"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_5'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-success"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="ClockIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>An Future Request has been placed to be delivered on <b>{{ flag.pivot.data.future_delivery_date }}</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length > 1"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_6'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-warning"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    icon="UmbrellaIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>An Fragile Request have been placed</span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length !== 0"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data && flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>

          <div v-if="flag.type === 'flag_7'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-avatar
                  size="25"
                  variant="light-danger"
                >
                  <feather-icon
                    icon="HomeIcon"
                    size="14"
                    class="text-body text-danger align-middle"
                  />
                </b-avatar>
              </span>
              <table>
                <tr><span>The order has been added to a temporary Warehouse <b>({{ flag.pivot.data.temporary_warehouse_name }})</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length !== 0"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data.other_data && flag.pivot.data.other_data.remark ? flag.pivot.data.other_data.remark : 'N/A' }}</b></span></tr>
              </table>
            </b-list-group-item>
          </div>
          <div v-if="flag.type === 'flag_8'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-avatar
                  size="25"
                  variant="light-info"
                >
                  <feather-icon
                    icon="RotateCwIcon"
                    size="14"
                    class="text-body align-middle"
                  />
                </b-avatar>
              </span>
              <table>
                <tr><span>The redelivery request has been added to this order by <b>({{ flag.pivot.data.merchant_name }})</b></span></tr>
                <tr
                  v-if="Object.keys(flag.pivot.data).length !== 0"
                >
                  <span class="remark-content">Remark: <b>{{ flag.pivot.data.other_data && flag.pivot.data.other_data.remark ? flag.pivot.data.other_data.remark : 'N/A' }}</b></span>
                </tr>
              </table>
            </b-list-group-item>
          </div>
          <div v-if="flag.type === 'flag_9'">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  variant="light-primary"
                  pill
                  class="oms-badge"
                  size="32"
                >
                  <feather-icon
                    icon="CloudIcon"
                    size="32"
                  />
                </b-badge>
              </span>
              <table>
                <tr><span>This order put into the system by Storemate OMS</span></tr>
              </table>
            </b-list-group-item>
          </div>
          <div v-if="flag.is_system === false">
            <b-list-group-item class="d-flex">
              <span class="mr-1">
                <b-badge
                  :variant="getCustomVariant(flag)"
                  pill
                  class="badge-round"
                  size="32"
                >
                  <feather-icon
                    :icon="getCustomIcon(flag)"
                    size="32"
                  />
                </b-badge>
              </span>

              <table>
                <tr>
                  <span>
                    A {{ flag.name }} Request has been placed
                  </span>
                </tr>

                <tr v-if="flag.pivot && flag.pivot.data">
                  <span class="remark-content">
                    Remark:
                    <b>{{ flag.pivot.data.remark ? flag.pivot.data.remark : 'N/A' }}</b>
                  </span>
                </tr>
              </table>
            </b-list-group-item>
          </div>
        </b-list-group>
      </div>
      <b-row
        v-if="errors.length > 0"
        class="mt-4"
      >
        <b-col>
          <b-table
            striped
            hover
            responsive
            :items="errors"
            :fields="fields"
          >
            <template #cell(status)="data">
              <b-badge variant="light-danger">
                {{ data ? 'error' : 'success' }}
              </b-badge>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BOverlay,
  VBModal,
  BButton,
  BCol,
  BFormGroup,
  BForm,
  BRow,
  BBadge,
  BListGroup,
  BListGroupItem,
  BAlert,
  BAvatar,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import SetRedelivery from './SetRedelivery.vue'
// import vSelect from 'vue-select'

const OrderRepository = RepositoryFactory.get('order')
const flagRepository = RepositoryFactory.get('flag')

function initialState() {
  return {
    open: false,
    isDisabled: false,
    id: null,
    wayBill: null,
    statusKey: null,
    selectedFlag: null,
    action: null,
    modalLoading: false,
    refreshParent: null,
    flagOptions: [],
    loading: false,
    form: {},
    customIconPool: [
      { icon: 'StarIcon', variant: 'light-primary' },
      { icon: 'TagIcon', variant: 'light-success' },
      { icon: 'GiftIcon', variant: 'light-info' },
      { icon: 'ZapIcon', variant: 'light-warning' },
      { icon: 'BookmarkIcon', variant: 'light-dark' },
      { icon: 'CompassIcon', variant: 'light-danger' },
    ],
    errors: [],
    fields: [
      {
        key: 'waybill_number',
        label: 'Waybill Number',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'status',
        label: 'Status',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'error',
        label: 'Error',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
    ],
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    SetRedelivery,
    BButton,
    BModal,
    BOverlay,
    BListGroup,
    BListGroupItem,
    BCol,
    BFormGroup,
    BForm,
    BRow,
    BBadge,
    BAlert,
    vSelect,
    BAvatar,
    BTable,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  methods: {
    async openModal(wayBill, statusKey, id) {
      Object.assign(this.$data, initialState())
      this.open = true
      this.wayBill = wayBill
      this.id = id
      this.statusKey = statusKey
      this.fetchFlagDetailsById()
      this.filterFlagOptions()
      this.refreshParent = this.$parent.onClickRefresh
    },
    async onClickSetFlag() {
      const flagObj = (this.selectedFlag && typeof this.selectedFlag === 'object')
        ? this.selectedFlag
        : this.flagOptions.find(f => f.name === this.selectedFlag)

      if (!flagObj || !flagObj.id) {
        this.showErrorMessage('Please Select an Action')
        return false
      }

      switch (flagObj.name) {
        case 'Redelivery':
          this.action = 0
          return true
        default:
          // try to apply custom flag (API) or emit fallback
          return this.applyCustomFlag(flagObj)
      }
    },
    async filterFlagOptions() {
      if (this.statusKey === 'key_11') {
        this.setNoActionsFound()
        return
      }
      const res = (await flagRepository.getFlagDropdownByStatus(this.statusKey))
      const flagData = res.data.data

      if (!flagData.length) {
        this.setNoActionsFound()
        return
      }

      if (this.statusKey === 'key_17' || this.statusKey === 'key_18' || this.statusKey === 'key_19') {
        const shouldReturn = await this.handleRedeliveryFlags(flagData)
        if (shouldReturn) {
          return
        }
      }
      this.flagOptions = flagData
    },
    async handleRedeliveryFlags(flagData) {
      const redeliveryFlag = flagData.find(flag => flag.name === 'Redelivery')
      if (!redeliveryFlag) return false

      const maxAttempt = await this.fetchRedeliveryFlagDetails(redeliveryFlag.id)
      const response = await OrderRepository.getAssignedRedeliveryFlagCount(this.id)
      this.redeliveryFlagsData = response.data.data
      this.redeliveryFlagsCount = this.redeliveryFlagsData.redelivery_flag_count

      if (maxAttempt !== -1 && this.redeliveryFlagsCount >= maxAttempt) {
        this.setDeliveryAttemptExceed()
        return true // Indicates that an early exit should occur
      }
      return false // Indicates to continue
    },
    async fetchRedeliveryFlagDetails(redeliveryFlagId) {
      try {
        const { data } = (await flagRepository.fetchFlagDetails(redeliveryFlagId)).data
        const maxAttemptStaff = data.max_attempt_staff
        return maxAttemptStaff
      } catch (e) {
        this.convertAndNotifyError(e)
        return -1
      }
    },
    setNoActionsFound() {
      this.flagOptions = [{ id: 0, name: 'No Actions Found for this Status' }]
      this.isDisabled = true
      this.selectedFlag = 'No Actions Found for this Status'
    },
    async fetchFlagDetailsById() {
      try {
        const { data } = (await OrderRepository.getOrderFlagDetailsById(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    setOpen(val) {
      this.open = val
    },
    setDeliveryAttemptExceed() {
      this.flagOptions = [{ id: 0, name: 'Maximum redelivery attempts reached.' }]
      this.isDisabled = true
      this.selectedFlag = 'Maximum redelivery attempts reached.'
    },
    async applyCustomFlag(flag) {
      if (!flag || !flag.id) {
        this.showErrorMessage('Invalid flag selected')
        return false
      }
      this.modalLoading = true
      try {
        this.action = 0
        return true
      } catch (e) {
        this.convertAndNotifyError(e)
        return false
      } finally {
        this.modalLoading = false
      }
    },
    getCustomIcon(flag) {
      const pool = this.customIconPool
      const index = flag.id ? Number(flag.id % pool.length) : flag.name.charCodeAt(0) % pool.length
      return pool[index].icon
    },
    getCustomVariant(flag) {
      const pool = this.customIconPool
      const index = flag.id ? Number(flag.id % pool.length) : flag.name.charCodeAt(0) % pool.length
      return pool[index].variant
    },
    setErrors(val) {
      this.errors = val
    },
  },
}
</script>
<style lang="scss">
.remark-content{
    word-break: break-all;
  }
.oms-badge svg {
  height: 1rem !important;
  width: 1rem !important;
}
</style>
